import React from 'react';
import '../less/transfers.less'
import hero_img from '../img/wu/hero_img.png';
import attention_icon from '../img/wu/attention_icon.svg'
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';
import { ReactSVG } from 'react-svg';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';
import ratesWithinUA from '../../../../../../API/transfers/wu/wu_ukraine.json';
import ruUSDRatesUa from '../../../../../../API/transfers/wu/ru_and_near_usd.json';
import ruUAHRatesUa from '../../../../../../API/transfers/wu/ru_and_near_uah.json';
import foreignUa from '../../../../../../API/transfers/wu/foreign.json';
import israelUSDRatesUa from '../../../../../../API/transfers/wu/israel_usd.json';
import israelUAHRatesUa from '../../../../../../API/transfers/wu/israel_uah.json';
import turkeyUSDRatesUa from '../../../../../../API/transfers/wu/turkey.json';
import turkeyUAHRatesUa from '../../../../../../API/transfers/wu/turkey_uah.json';
import chinaUSDRatesUa from '../../../../../../API/transfers/wu/china.json';
import chinaUAHRatesUa from '../../../../../../API/transfers/wu/china_uah.json';
import uaeUSDRatesUa from '../../../../../../API/transfers/wu/uae.json';
import uaeUAHRatesUa from '../../../../../../API/transfers/wu/uae_uah.json';
import CustomDropdownNew from '../../../../../auxiliary-components/shared/CustomDropdownNew';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock';
import { transfersAttentionUrl, wuBannerLink } from '../../../../../services/urls/urls';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'wu-new';

    const hero_data = {
      title: 'WU_NEW_HERO_TITLE',
      text: 'WU_NEW_HERO_TEXT',
      link: {
        text: "WU_NEW_HERO_BTN",
        onClick: () => window.open(wuBannerLink, "_blank"),
      }
    }

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="wu-new">
        <Hero
          data={hero_data}
          img={hero_img}
          className="transfers"
          page={page}
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <InfoBlock
                title={`WU_NEW_INFO_TITLE_01`}
                text={`WU_NEW_INFO_TEXT_01`}
              />
              <div className="wu-new__tariffs tariffs-wu-new">
                <TitleBlock title={'WU_NEW_TARIFFS_TITLE'}/>
                <CustomDropdownNew title={this.l10n("WU_TARIFFS_WITHIN_UKRAINE")} page={page} id={'tariffs-within-ukraine'}>
                  <div>
                    <TransferTableNew data={ratesWithinUA}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("WU_TARIFFS_WITHIN_RUSSIA")} page={page} id={'tariffs-near-abroad'}>
                  <div>
                    <TransferTableNew data={ruUSDRatesUa}/>
                    <TransferTableNew data={ruUAHRatesUa}/>
                  </div>
                  <div className="tariffs-wu-new__disclaimer">
                    <div className="container">
                      {this.l10n("WU_DISCLAIMER_2")}
                    </div>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("WU_TARIFFS_FAR_FOREIGN_COUNTRIES")} page={page} id={'tariffs-far-abroad'}>
                  <div>
                    <TransferTableNew data={foreignUa}/>
                    <TransferTableNew data={israelUSDRatesUa}/>
                    <TransferTableNew data={israelUAHRatesUa}/>
                  </div>
                  <div className="tariffs-wu-new__disclaimer">
                    <div className="container">
                      <p>{this.l10n("WU_EXPLANATION_TEXT_1")}</p>
                      <p>{this.l10n("WU_EXPLANATION_TEXT_2")}</p>
                      <p>{this.l10n("WU_EXPLANATION_TEXT_3")}</p>
                    </div>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("WU_TARIFFS_TURKEY")} page={page} id={'tariffs-turkey'}>
                  <div>
                    <TransferTableNew data={turkeyUSDRatesUa}/>
                    <TransferTableNew data={turkeyUAHRatesUa}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("WU_TARIFFS_CHINA_UAE")} page={page} id={'tariffs-china-uae'}>
                  <div>
                    <TransferTableNew data={chinaUSDRatesUa}/>
                    <TransferTableNew data={chinaUAHRatesUa}/>
                    <TransferTableNew data={uaeUSDRatesUa}/>
                    <TransferTableNew data={uaeUAHRatesUa}/>
                  </div>
                </CustomDropdownNew>
                <div className="tariffs-wu-new__hint">
                  <div className="container">
                    {this.l10n("WU_TARIFFS_HINT")}
                  </div>
                </div>
              </div>
              <div className="wu-new__info-block">
                <InfoBlock
                  text={'WU_NEW_INFO_TEXT_02'}
                />
                <InfoBlock
                  text={'WU_NEW_INFO_TEXT_03'}
                />
                <div className="attention-block">
                  <div className="container">
                    <div className="attention-block__body">
                      <div className="attention-block__title">
                        <ReactSVG src={attention_icon} className="attention-block__icon"/>
                        {this.l10n('WU_NEW_ATTENTION_BLOCK_TITLE')}
                      </div>
                      <div className="attention-block__text">
                        <ul>
                          <li>{this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_01')}</li>
                          <li>{this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_02')}</li>
                          <li>{this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_03')}</li>
                          <li>{this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_04')}</li>
                          <li>{this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_05')}</li>
                          <li>{this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_06')}</li>
                          <li>{this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_07')}</li>
                          <li>
                            {this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_08_1')}
                            <a href={transfersAttentionUrl} target='_blank' rel='noopener noreferrer'>{this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_08_2')}</a>
                          </li>
                        </ul>
                        <p>
                          {this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_09')}
                          <a href="/about/general" target='_self' onClick={(e) => this.navigate("/about/general", e)}>{this.l10n('WU_NEW_ATTENTION_BLOCK_LINK_01')}</a>
                        </p>
                        <p>
                          {this.l10n('WU_NEW_ATTENTION_BLOCK_TEXT_10')}
                          <a href="/forpartners" target='_self' onClick={(e) => this.navigate("/forpartners", e)}>{this.l10n('WU_NEW_ATTENTION_BLOCK_LINK_02')}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <QuestionsAdminNew
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'FAQ_SHORT_NEW_TITLE'}
                page={page}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
      </div>
    );
}
